import { useEffect } from "react";
import {
  hasShownBookingSurvey,
  markBookingSurveyShown,
  openBookingSurveyDeeplink,
  type CsatVertical,
} from "../utils/csatSurvey";

type UseBookingSurveyConfirmationOptions = {
  vertical: CsatVertical;
  bookingId?: string;
  enabled?: boolean;
};

export function useBookingSurveyConfirmation({
  vertical,
  bookingId,
  enabled = false,
}: UseBookingSurveyConfirmationOptions) {
  useEffect(() => {
    if (!enabled || hasShownBookingSurvey(vertical)) {
      return;
    }

    markBookingSurveyShown(vertical);
    openBookingSurveyDeeplink({
      vertical,
      screen: "booking_confirmation",
      bookingId,
    });
  }, [enabled, vertical, bookingId]);
}
